export const integerRegex = /^\d{*}$/g;
export const decimalRegex = /^-?\d*\.?\d{0,2}$|^-?\d+$/g;
export const idRegex = /^[A-Za-z0-9\-]{1,}$/g;